import { FirebaseData } from "../General/FirebaseData";

export default class VendorConnectionData extends FirebaseData {

    unlocId: string = "";
    email: string = "";
    password: string = "";

    setup(data: any) {
        if (typeof data.unlocId === "string") {
            this.unlocId = data.unlocId;
        }
        if (typeof data.email === "string") {
            this.email = data.email;
        }
        if (typeof data.password === "string") {
            this.password = data.password;
        }
        super.setup(data);
    }
}